<template lang="pug">
	.form-group.fg-am
		.d-flex.justify-content-between(style="height: 18px")
			label Account Manager
			b-checkbox(switch="", v-model="amOptionsArchive")
		multiselect(:multiple="multiple", :options="visibleAMOptions",
			:value="value", @input="onChange",
			track-by="v", label="t", deselect-label="", select-label="", :show-labels="multiple")

</template>
<script>
import Vue from 'vue';

export default {
  name: 'SelectAM',
  props: {
    value: {
      type: [Array],
    },
    multiple: {
      type: [Boolean],
      default() {
        return true;
      },
    },
  },
  computed: {
    visibleAMOptions() {
      return this.amOptions.filter((a) => {
        return this.amOptionsArchive ? true : a.status === 1;
      });
    },
  },
  data() {
    return {
      amOptions: [],
      amOptionsArchive: false,
    };
  },
  methods: {
    onChange(value) {
      this.$emit('input', value);
    },
  },
  async mounted() {
    this.amOptions = await Vue.ovData.user.getOptions(true, ['admin', 'am']);
  },
};
</script>
